export default __webpack_public_path__ + "static/media/Navy_Gi_Logo_-_Transparent.45f5df4e.png";